// Apple-style eased scroll — smoother and more consistent across browsers
// than the native `behavior: "smooth"`, which is fairly linear and varies
// per engine. Returns a cancel function so callers can stop mid-flight.
function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

export function animateScrollTo(targetY, duration = 700) {
  const startY = window.scrollY;
  const diff = targetY - startY;
  if (Math.abs(diff) < 1) return () => {};

  const startTime = performance.now();
  let rafId;
  let cancelled = false;

  const step = (now) => {
    if (cancelled) return;
    const progress = Math.min((now - startTime) / duration, 1);
    window.scrollTo(0, startY + diff * easeInOutCubic(progress));
    if (progress < 1) rafId = requestAnimationFrame(step);
  };

  rafId = requestAnimationFrame(step);
  return () => {
    cancelled = true;
    cancelAnimationFrame(rafId);
  };
}
